import { Link } from 'react-router-dom'
import { LuPlus } from 'react-icons/lu'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

export default function NodesEmptyState() {
  return (
    <Box>
      <Stack sx={{
        gap: 3
      }}>
        <Typography variant="h2">Register a node</Typography>
        <Typography variant="body1">
          Nodes are machines connected to your noBGP network. Install the noBGP agent to enable AI-powered management,
          remote command execution, and seamless service publishing.
        </Typography>

        <Box>
          <Typography variant="subtitle2" sx={{
            marginBottom: 1
          }}>
            How to add a node:
          </Typography>
          <ol style={{ margin: 0, paddingLeft: 24 }}>
            <Typography component="li" variant="body2">
              Click the "Add Node" button below to generate an installation command
            </Typography>
            <Typography component="li" variant="body2">
              Run the command on your server with sudo privileges
            </Typography>
            <Typography component="li" variant="body2">
              Your node will automatically connect and appear here
            </Typography>
          </ol>
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{
            marginBottom: 1
          }}>
            Requirements:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 24 }}>
            <Typography component="li" variant="body2">
              Linux-based system (Alpine, Amazon Linux, Debian, or Ubuntu)
            </Typography>
            <Typography component="li" variant="body2">
              Root or sudo access
            </Typography>
            <Typography component="li" variant="body2">
              Outbound internet access to the noBGP router
            </Typography>
          </ul>
        </Box>

        <Box>
          <Button component={Link} to="/node" startIcon={<LuPlus />} size="small" variant="outlined">
            Add a node
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
